<template>
  <CustomerReviews :key="key" />
</template>

<script>
import CustomerReviews from '@/components/pdp/organisms/CustomerReviews.vue'
import { usePdpStore } from '@/stores/pdp'
import { mapState } from 'pinia'

export default {
  name: 'CustomerReviewsWrapper',
  components: { CustomerReviews },
  computed: {
    ...mapState(usePdpStore, { product: 'getApiV1Product' }),
    key() {
      return `reviews_${this.product.product_id}_${this.product.campaign_id}`
    }
  }
}
</script>
